export default class grid {
   constructor(el){
      this.wrap = el;
      this.items = $(el).children();
      window.grid = this;

      this.bind();
   }

   bind(){
      const self = this;

      $(this.items).off('click').on('click', function(e){
         if(e.ctrlKey || e.shiftKey || e.altKey || e.metaKey) {
         } else {
            e.preventDefault();
            e.stopPropagation();
            
            var item, container;
            
            if($(this).hasClass('vidplayer')){
               container = $(this);
               item = $(this).children('.video-player');
            } else {
               container = item = $(this);
            }
            
            self.pop(item, container);
         }
      });

      $(window).on('popstate', function(e){
         window.prevStateChange = true;
         // let url = window.location.href;
         let url = window.location.href.split($('meta[property="og:url"]').attr('content'));
         console.log(url);
         if(url.length>1 && url[1]!=''){
            if($(`a[href*="${url[1]}"]`).length>0){
               $(`a[href*="${url[1]}"]`).click();
            } else {
               $('.pop').click();
            }
         } else {
            $('.pop').click();
         }
      });
   }

   pop(item, container){
      const self = this;
      // console.log(item);
      $('.cur').removeClass('cur');
      $(container).addClass('cur');

      // $('html').addClass('no-overflow');

      var t = $(item).clone();
      $(t).find('[data-src]').each(function(){
         let src = $(this).attr('data-src');
         $(this).attr('src', src);
      });

      if($('.pop').length==0){
         var nav = `<span class='pop--prev'>&larr;</span><span class='pop--next'>&rarr;</span>`;
         var popinfo = `<span class='pop--info'></span>`;
         $('body').append(`<div class="pop fromgrid"><div class="pop--content" style="opacity:0;"></div>${nav}${popinfo}</div>`);
         // $('.pop--content').append(t);
         if(!window.prevStateChange){
            window.history.pushState({}, '', $(item).attr('href'));
         }
         window.prevStateChange = false;
         $('.pop--content').load($(item).attr('href')+' article.project', function(){
            $(window).trigger('scroll');
            $('.pop--content').animate({'opacity' : 1}, 400);
         });
         self.bindPop();
         setTimeout(function(){
            $('.pop').addClass('in');
         }, 50);
      } else {
         $('.pop--content').animate({'opacity' : 0}, 200, function(){
            $('.pop--content').empty();
            // $('.pop--content').append(t);
            if(!window.prevStateChange){
               window.history.pushState({}, '', $(item).attr('href'));
            }
            window.prevStateChange = false;
            $('.pop--content').load($(item).attr('href')+' article.project', function(){
               $(window).trigger('scroll');
               $('.pop--content').animate({'opacity' : 1}, 200);
            });
         });
      }

      // if($(item).attr('data-info')) {
      //    $('.pop--info').html($(item).attr('data-info'));
      // } else {
      //    $('.pop--info').empty();
      // }

   }

   bindPop(){
      $('.pop').on('click', function(e){
        if(e.target==this || $(e.target).hasClass('pop--content')) {
         $('.pop').removeClass('in');
         setTimeout(function(){
            $('.pop').remove();
         }, 300);
         if(!window.prevStateChange){
            window.history.pushState({}, '', $('meta[property="og:url"]').attr('content'));
         }
         window.prevStateChange = false;
         $('.cur').removeClass('cur');
        }
      });

      $('.pop--prev').on('click', function(){
         if($('.cur').prev().length > 0){
            $('.cur').prev().click();
         } else {
            $('.pop').click();
         }
      });

      $('.pop--next').on('click', function(){
         if($('.cur').next().length > 0){
            $('.cur').next().click();
         } else {
            $('.pop').click();
         }
      });

      if(!window.popBound) {
         window.popBound = true;
         $(document).on('keyup', function(e){
            if(e.code == 'ArrowLeft'){
               $('.pop--prev').click();
            }
            if(e.code == 'ArrowRight') {
               $('.pop--next').click();
            }
            if(e.code == 'Escape') {
               $('.pop').click();
            }
         });
      }
   }
}